import * as React from "react";
import HomeContainer from "../conteiners/home-container";

export default function InicioPage() {
  return <HomeContainer></HomeContainer>;
}
